import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TabsStateService } from "@shared/services/tabs-state/tabs-state.service";
import { Button } from "primeng/button";

@Component({
    selector: "app-notfound",
    templateUrl: "./notfound.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [Button],
})
export class NotfoundComponent {
    private readonly router = inject(Router);
    private readonly tabsService = inject(TabsStateService);

    redirectBack() {
        let url = "/";
        let queryParams = null;

        const activeTab = this.tabsService.getActiveTab();

        if (activeTab) {
            url = activeTab.tabComponentUrl;
            queryParams = { ...activeTab.queryParams, tabId: activeTab.tabId };
        }

        this.router.navigate([url], { queryParams });
    }
}
